import { Box, Card, Grid, MenuItem, Typography } from "@mui/material";
import React from "react";
import CustomButton from "../../components/customButton";
import { CircleUser, ClipboardCheck, User } from "lucide-react";

import CustomSelect from "../../components/customSelect";
import ProfileCard from "../../components/employeeProfileCards/profileCard";
import CalendarCard from "../../components/employeeProfileCards/calenderCard";
import DailyLogCard from "../../components/card/logsCard";
import PaginatedTable from "../../components/dynamicTable";

const BreakManagement = () => {
    const employee = {
        name: "Willian Jhonson",
        designation: "Graphic Designer",
        id: "174007",
        phone: "+1 2235467898",
        email: "williamjhonson2@gmail.com",
        photo: "https://randomuser.me/api/portraits/men/32.jpg",
        checkIn: "10:33 AM",
        checkOut: "19:33 PM",
    };
    const logData = {
        title: "Break Log",
        inName: "Break In",
        outName: "Break Out",
        inTime: "8:15 AM",
        outTime: "4:30 PM",
        totalLate: "7 Late",
        status: "On time",
    };

    const attendanceTableHeaders = [
        { id: "employeeName", title: "Employee Name", align: "center" },
        { id: "timeIn", title: "Time In", align: "center" },
        { id: "timeOut", title: "Time Out", align: "center" },
        { id: "status", title: "Status", align: "center" },
    ];

    const tableData = [
        {
            employeeName: "William",
            timeIn: "8:15 AM",
            timeOut: "4:30 PM",
            status: "On time",
        },
        {
            employeeName: "William",
            timeIn: "8:15 AM",
            timeOut: "4:30 PM",
            status: "On time",
        },
        {
            employeeName: "William",
            timeIn: "8:15 AM",
            timeOut: "4:30 PM",
            status: "On time",
        },
        {
            employeeName: "William",
            timeIn: "8:15 AM",
            timeOut: "4:30 PM",
            status: "On time",
        },

    ];

    const displayRows = attendanceTableHeaders.map((header) => header.id);
    return (
        <>
            <Box bgcolor="primary.bgLight" padding={"20px"} borderRadius={"22px"} mt={0} >
                <Grid container spacing={2}>
                    <Grid item sm={12} md={5}>
                        <Typography variant="h4">
                            Break Management
                        </Typography>
                        <Typography variant="description">
                            Monitor break adherence and duration
                        </Typography>

                    </Grid>
                    <Grid item sm={12} spacing={2} md={7}>
                        <Box sx={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>
                            <CustomSelect
                                // label={"Select Worker"}
                                name="worker"
                                // value={form.worker}
                                // onChange={handleChange}
                                placeholder="Select Worker"
                                endIcon={<User size={16} />}
                                sx={{ width: "100%", height: "36px" }}
                                InputWidth="40%"
                            >
                                <MenuItem value="090909">James</MenuItem>
                                <MenuItem value="09090909">Velverde</MenuItem>
                                <MenuItem value="09090909">Arda</MenuItem>
                                <MenuItem value="09090909">Gular</MenuItem>
                            </CustomSelect>
                        </Box>
                    </Grid>
                </Grid>




                <Grid container spacing={3}>
                    {/* Profile Card */}
                    <Grid item xs={12} md={3}>
                        <ProfileCard
                            employee={employee}
                        />
                    </Grid>
                    {/* Analytics Cards */}
                    <Grid item xs={12} md={9}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <DailyLogCard {...logData} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box sx={{
                                    border: "2px solid #2E7D32",
                                    borderRadius: "18px",
                                    bgcolor: "#fff",
                                }}>
                                    <CalendarCard data={{}} />
                                </Box>
                            </Grid>
                        </Grid>
                        <Box mt={3}>

                        </Box>
                    </Grid>
                </Grid>


                <Box mt={1}>
                    <PaginatedTable
                        tableHeader={attendanceTableHeaders}
                        tableData={tableData}
                        displayRows={displayRows}
                        showPagination={false}
                    />
                </Box>




            </Box>


        </>
    );
};

export default BreakManagement;   